import {TranslationCell, ArrayCell, FirmStatusCell} from '~/components/advanced_table/components/cells'
import {formatDate, formatMoney, buildColumn} from '@eitje/web_components'
import {getFirmStatus} from '~/helpers'

export const columns = [
	{
		accessorKey: 'formatted_invoice_number',
	},
	{
		id: 'status',
		accessorFn: invoice => `records.default.fields.invoice_status.${invoice.status}`,
		cell: TranslationCell,
		aggregates: false,
	},
	{
		id: 'total_amt',
		accessorFn: invoice => Number(invoice.total_amt),
		format: formatMoney,
		collapsibleCell: 'sumValues',
		aggregatesFn: 'sumValues',
	},
	{
		accessorKey: 'billing_date',
		format: formatDate,
		aggregates: false,
	},
	{
		accessorKey: 'ignore_mollie',
		cell: 'BooleanCell',
		infoIconMessageProps: {
			title: 'records.default.fields.ignore_mollie',
			body: 'tooltips.ignore_mollie',
		},
	},
	{
		accessorKey: 'pdf',
		cell: 'ExtLinkCell',
		t: 'common.download',
	},
	{
		id: 'organisation',
		accessorFn: invoice => invoice.organisation?.name,
	},
	{
		id: 'organisation_status',
		accessorFn: invoice => getFirmStatus(invoice.organisationEnvironments),
		cell: FirmStatusCell,
		infoIconMessageProps: {
			title: 'tooltips.organisation_status.title',
			body: 'tooltips.organisation_status.body',
		},
	},
	{
		id: 'company_name',
		accessorFn: invoice => invoice.billingInfo?.company_name,
	},
	{
		id: 'environments',
		accessorFn: invoice => invoice.environments?._map('naam'),
		cell: ArrayCell,
		aggregates: false,
	},
	{
		id: 'amt',
		accessorFn: invoice => Number(invoice.amt),
		format: formatMoney,
		collapsibleCell: 'sumValues',
		aggregatesFn: 'sumValues',
	},
	{
		id: 'vat',
		accessorFn: invoice => _.round(invoice.total_amt - invoice.amt, 2),
		format: formatMoney,
		collapsibleCell: 'sumValues',
		aggregatesFn: 'sumValues',
	},
	{
		accessorKey: 'id',
	},
].map(buildColumn)
